<template>
  <div>
    <div class="mt-28px">
      <div class="flex items-center justify-between">
        <p class="title">{{ $t(title) }}</p>
        <vs-button color="secondary" @click="openPopup">{{ $t(addButtonName) }}</vs-button>
      </div>
      <vs-table ref="companyTable" v-model="selectCompany" @selected="handleSelected" pagination :max-items="tableMaxItems" :data="companyList" class="mt-5">
        <template slot="thead">
          <vs-th><span class="w-full text-center">No.</span></vs-th>
          <vs-th v-for="tHead in tableColumns" :key="`head-${tHead.key}`"><span class="w-full text-center">{{ $t(tHead.head) }}</span></vs-th>
          <vs-th><span class="w-full text-center">{{ $t('삭제') }}</span></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><div class="w-full text-center">{{ getRowNumber(indextr) }}</div></vs-td>
            <vs-td v-for="tBody in tableColumns" :key="`body-${tBody.key}`"><div class="w-full text-center">{{ data[indextr][tBody.key] || '-' }}</div></vs-td>
            <vs-td>
              <div class="w-full text-center">
                <vs-button size="small" color="danger" type="border" @click.stop="removeCompanyByIndex(indextr)">{{ $t('삭제') }}</vs-button>
              </div>
            </vs-td>
          </vs-tr>
          <div></div>
        </template>
      </vs-table>
    </div>
    <div v-if="!isSimple" class="mt-28px">
      <div class="flex items-center justify-between">
        <p class="title">{{ $t(detailTitle) }}</p>
        <vs-button color="secondary" type="border" @click="removeCompany">{{ $t('삭제') }}</vs-button>
      </div>
      <div class="mt-5">
        <div class="writeGridContainer">
          <div>
            <search-nav-item-select class="search-item" :label="$t('구분')" v-model="selectCompany.com_type" :list="comTypes" :readonly="true" />
          </div>
        </div>
        <div class="writeGridContainer">
          <div>
            <div>{{ detailLabelComName }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_name" />
          </div>
          <div>
            <div>{{ $t('대표자') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_ceo" />
          </div>
          <div>
            <div>{{ $t('사업자번호') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_number" />
          </div>
          <div>
            <div>{{ $t('주소') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_address" />
          </div>
          <div>
            <div>{{ $t('업태') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_business_class" />
          </div>
          <div>
            <div>{{ $t('업종') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_business_type" />
          </div>
          <div>
            <div>{{ $t('담당자') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.director" />
          </div>
          <div>
            <div>{{ $t('연락처') }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.phone" />
          </div>
        </div>
      </div>
    </div>

    <popup-search-company :title="popupTitle" :multiple="true" :initSelectedCompanies="companyList" v-model="showPopup" @handleClickSelect="handleClickSelect" />
  </div>
</template>

<script>
import PopupSearchCompany from "@/popup/PopupSearchCompany";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
export default {
  name: "CompanyAddModule",
  components: {
    SearchNavStartEnd,
    SearchNavItemSelect,
    PopupSearchCompany,
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "담당 부서(업체) 정보";
      },
    },
    isSimple: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    detailTitle: {
      type: String,
      default: () => {
        return "부서(업체) 세부 정보";
      },
    },
    detailLabelComName: {
      type: String,
      default: () => {
        return "부서(업체)명";
      },
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [
          { head: "구분", key: "com_type" },
          { head: "부서(업체)명", key: "com_name" },
          { head: "대표자", key: "com_ceo" },
          { head: "담당자", key: "director" },
          { head: "연락처", key: "phone" },
        ];
      },
    },
    popupTitle: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    addButtonName: {
      type: String,
      default: () => {
        return "추가";
      },
    },
  },
  data() {
    return {
      showPopup: false,
      tableMaxItems: 5,
      nav: {
        selects: [
          {
            text: "1",
            value: "1",
          },
        ],
      },
      selectCompany: {},
      companyList: this.value,
      comTypes: [
        {
          text: "본청",
          value: "본청",
        },
        {
          text: "도급",
          value: "도급",
        },
        {
          text: "용역",
          value: "용역",
        },
        {
          text: "위탁",
          value: "본청",
        },
        {
          text: "기타",
          value: "기타",
        },
      ],
    };
  },
  watch: {
    value(data) {
      this.companyList = this.value;
    },
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    handleSelected() {
      this.$emit("selected", this.selectCompany);
    },
    handleClickSelect(companies) {
      if (Array.isArray(companies)) {
        const newIds = companies.map((c) => c.id);
        const removed = this.companyList.filter((c) => newIds.indexOf(c.id) === -1);
        this.companyList.splice(0, this.companyList.length);
        for (const company of companies) {
          this.companyList.push(company);
        }
        for (const company of removed) {
          this.$emit("remove", company);
        }
      } else {
        if (this.findCompanyIndex(companies) <= -1) {
          this.companyList.push(companies);
        }
      }
    },
    findCompanyIndex(company) {
      let i = 0;
      for (i = 0; i < this.companyList.length; i++) {
        const com = this.companyList[i];
        if (com.id === company.id) {
          return i;
        }
      }
      return -1;
    },
    removeCompany() {
      if (this.selectCompany && this.selectCompany.id) {
        const index = this.findCompanyIndex(this.selectCompany);
        if (index >= 0) {
          const company = this.companyList[index];
          this.companyList.splice(index, 1);
          this.$emit("remove", company);
        }
      }
    },
    removeCompanyByIndex(pageIndex) {
      const absoluteIndex = this.getAbsoluteIndex(pageIndex);
      const company = this.companyList[absoluteIndex];
      this.companyList.splice(absoluteIndex, 1);
      this.$emit("remove", company);
    },
    getAbsoluteIndex(pageIndex) {
      const currentPage = this.$refs.companyTable ? this.$refs.companyTable.currentx : 1;
      return ((currentPage - 1) * this.tableMaxItems) + pageIndex;
    },
    getRowNumber(pageIndex) {
      const currentPage = this.$refs.companyTable ? this.$refs.companyTable.currentx : 1;
      return ((currentPage - 1) * this.tableMaxItems) + pageIndex + 1;
    },
  },
};
</script>

<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.size-search {
  width: 200px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}
.search-item {
  width: 100% !important;
  margin: 0 !important;
  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }
  &::v-deep > div:last-child {
    flex: 1 !important;
    .con-select {
      width: 100%;
    }
  }
}
.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
